import PatientFirm from "./PatientFirm.jsx";

export default PatientFirm;
